import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Grid,
  GridItem,
  Heading,
  Text
} from "@chakra-ui/react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { translateSubElementString } from "../../../../../../utils";
import { DimensionEmissionsGridItems } from "./index";
import { MissingDataGridItems } from "../../MissingDataGridItems";
import { useGetOrganizationStructure } from "../../../../../../hooks/query";
import { useEffect, useState } from "react";
import { IconTitle } from "../../../../../../components/IconTitle";
import { NumberField } from "../../../../../../components/NumberField";

function DimensionGridAccordionItem({ data, titleKey, type }) {
  const { t } = useTranslation("translation");

  const [sectionItems, setSectionItems] = useState([]);

  const {
    data: organizationStructure
  } = useGetOrganizationStructure();

  useEffect(() => {
    if (organizationStructure) {
      let items;

      switch (type) {
        case "stationary":
          items = organizationStructure.stationaryConsumptionTypes;
          break;
        case "mobile":
          items = organizationStructure.mobileConsumptionTypes;
          break;
        case "refrigerant":
          items = organizationStructure.refrigerantConsumptionTypes;
          break;
        case "electricity":
          items = organizationStructure.electricityTypes;
          break;
        default:
          items = [];
      }

      setSectionItems(items);
    }
  }, [organizationStructure, type]);

  return (
    <AccordionItem>
      {
        ({ isExpanded }) => {
          return <>
            <h2>
              <AccordionButton>
                <Box flex="1" textAlign="left">
                  <Heading color="esg_gray.200" size="xs">
                    {t(`reportsPage.${titleKey}`)}
                  </Heading>
                </Box>
                <Text fontSize={"sm"} mr={2}>
                  {isExpanded ? t("buttons.collapse") : t("buttons.expand")}
                </Text>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pt={2} pb={5} overflow="auto">
              <Grid templateColumns="repeat(3, 1fr)" gap={2}>
                <GridItem>
                </GridItem>
                <GridItem>
                  <Heading marginBlock="1" align="right" size="sm">
                    {t("reportsPage.totalConsumption")}
                  </Heading>
                </GridItem>
                <GridItem>
                  <Heading marginBlock="1" align="right" size="sm">
                    {translateSubElementString("reportsPage.totalEmissions")}
                  </Heading>
                </GridItem>
                {!data || !data[type] || sectionItems.length === 0 ?
                  <MissingDataGridItems key={`${type}-missing-items`} value={"n/a"} /> :
                  <DimensionEmissionsGridItems data={data} sectionItems={sectionItems} dataType={type} />
                }
              </Grid>
              {type !== "electricity" ?
                <Grid templateColumns="repeat(3, 1fr)" gap={2} overflow="auto" marginTop={4}>
                  <GridItem>
                    <IconTitle
                      icon={undefined}
                      title={translateSubElementString(`reportsPage.${type}Total`)}
                      subTitle={` (${t(`measures.tonnes`)})`}
                    />
                  </GridItem>
                  <GridItem></GridItem>
                  <GridItem>
                    <NumberField fontWeight="bold" value={data[type].totalCo2Emissions} />
                  </GridItem>
                </Grid> : null
              }
            </AccordionPanel>
          </>;
        }
      }
    </AccordionItem>
  );
}

export default DimensionGridAccordionItem;